
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, LogOut, ChevronDown, ChevronUp } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';

type ProfileDropdownProps = {
  userName: string;
  userInitials: string;
  userTitle?: string;
  avatarUrl?: string | null;
  onSignOut: () => Promise<void>;
};

const ProfileDropdown = ({ 
  userName, 
  userInitials, 
  userTitle,
  avatarUrl,
  onSignOut 
}: ProfileDropdownProps) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <div className="mt-auto px-4 py-4 border-t border-gray-200">
      <Collapsible
        open={isOpen}
        onOpenChange={setIsOpen}
        className="w-full"
      >
        <CollapsibleTrigger asChild>
          <Button 
            variant="ghost" 
            className="w-full justify-start p-2 hover:bg-gray-100"
          >
            <div className="flex items-center w-full">
              <Avatar className="h-8 w-8 mr-2">
                {avatarUrl ? (
                  <AvatarImage src={avatarUrl} alt={userName} />
                ) : null}
                <AvatarFallback className="bg-yellow-500 text-darkgray">
                  {userInitials}
                </AvatarFallback>
              </Avatar>
              <div className="flex-1 text-left">
                <span className="block">{userName}</span>
                {userTitle && (
                  <span className="text-xs text-gray-500">{userTitle}</span>
                )}
              </div>
              {isOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
            </div>
          </Button>
        </CollapsibleTrigger>
        <CollapsibleContent className="space-y-1 pt-2">
          <Button
            variant="ghost"
            className="w-full justify-start text-gray-600 hover:text-darkgray pl-10"
            onClick={() => navigate('/profile')}
          >
            <User size={16} className="mr-2" />
            Min profil
          </Button>
          <Button
            variant="ghost"
            className="w-full justify-start text-gray-600 hover:text-darkgray pl-10 text-xs"
            onClick={onSignOut}
          >
            <LogOut size={14} className="mr-2" />
            <span className="text-xs">Logga ut</span>
          </Button>
        </CollapsibleContent>
      </Collapsible>
    </div>
  );
};

export default ProfileDropdown;
